import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledVideo = styled.div`
  position: relative;
  padding-top: 56.25%;
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const StyledPoster = styled.div`
  cursor: pointer;
  position: relative;

  .play-btn {
    position: absolute;
    z-index: ${themeGet('zIndex.zIndex01')};
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${themeGet('color.colorBlue')};
    width: ${themeGet('scale.scaleUp11')};
    height: ${themeGet('scale.scaleUp11')};
    border-radius: 50%;
    box-shadow: 0 0 1px 0 #a8b9d5, 0 8px 16px -4px #ebf2ff;

    svg {
      margin: 0 0 0 ${themeGet('scale.scaleDown04')};
      width: ${themeGet('scale.scaleUp03')};
    }
  }
`;

export const StyledVideoEmbed = styled.div`
  ${StyledVideo} {
    visibility: ${(props) => (props.isReady ? 'visible' : 'hidden')};
    display: ${(props) => (props.showVideo ? 'block' : 'none')};
  }

  ${StyledPoster} {
    display: ${(props) => (props.showPoster ? 'block' : 'none')};
  }
`;
